import React, { useState } from "react";
import SvgCopy from "../assets/SvgCopy";
import projectOptions from "../project-options";
import { copyText } from "../util/copy-text";
import { t } from "src/shared/locales/i18n";
import Discount from "./Discount";
import { DivCoupon } from "../style/Coupon.style";

type Props = {
  productDiscount?: string;
  showDiscountInsideCoupon?: boolean;
  showCopyIcon?: boolean;
};

const Coupon = ({
  productDiscount,
  showDiscountInsideCoupon,
  showCopyIcon,
}: Props) => {
  const [isCopied, setIsCopied] = useState(false);
  const { showCouponCode, couponText } = projectOptions.default.style.product;

  function copyDiscountCodeToClipboard() {
    copyText(couponText, onDiscount);
  }

  function onDiscount() {
    setIsCopied(true);
  }

  if (!showCouponCode) return null;

  const CopyIcon = () => {
    if (!showCopyIcon) return null;

    return (
      <span
        className="akn-copy-icon-container"
        onClick={copyDiscountCodeToClipboard}
      >
        {!isCopied && <SvgCopy />} {isCopied ? t("copied") : t("copy")}
      </span>
    );
  };

  if (showDiscountInsideCoupon && productDiscount) {
    return (
      <>
        <DivCoupon>
          <div className="coupon-with-discount">
            <div className="coupon-with-discount__text">
              {couponText ? couponText : t("coupon_code")}
            </div>
            <Discount showMinus={true} productDiscount={productDiscount} />

            <CopyIcon />
          </div>
        </DivCoupon>
      </>
    );
  }

  return (
    <>
      <DivCoupon>
        <div className="akn-coupon-without-discount" style={{}}>
          <div className="akn-coupon-text">{couponText}</div>
          <span
            className="akn-copy-icon-container"
            onClick={copyDiscountCodeToClipboard}
          >
            <CopyIcon />
          </span>
        </div>
      </DivCoupon>
    </>
  );
};

export default Coupon;
